import React from 'react';
import {EntityUl, Modal} from '../styles/entity_sel_styles';
import EntityBar from '../components/entitybar.js';

const EntityList = (props) => {

    let title_status = false
    let entities = []
    for(var i in props.entities){
      if(props.entities[i].id !== props.entity_selected){
        entities.push(props.entities[i])
      }
    }
    if(props.visible){
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
    }

    return(
      <Modal visible={props.visible} onClick={()=> props.onModalClick()}>
        <EntityUl visible={props.visible}>
        {entities.sort().map((entity, ndx) =>
        (
          <EntityBar
          descriptors={entity}
          onEntitySelect={props.onEntitySelect}
          key = {ndx}
          ndx = {ndx}
          title = {title_status}
          />
          )
        )
        }
        </EntityUl>
      </Modal>
    )
  }

export default EntityList;
